export default class Delay {
    constructor() {
        this.init();
    }

    init() {
        let containers = document.querySelectorAll( '[data-delay="container"]' );

        containers.forEach( ( container ) => {
            let items = container.querySelectorAll( '[data-delay="item"]');
            let init = container.hasAttribute( 'data-delay-init' ) ? parseInt( container.getAttribute( 'data-delay-init' ) ) : 0;
            let step = container.hasAttribute( 'data-delay-step' ) ? parseInt( container.getAttribute( 'data-delay-step' ) ) : 200;
            let count = items.length;
            let delays = [];

            for ( var i = 0; i < count; i++ ) {
                delays.push( ( i * step ) + init );
            }

            items.forEach( ( item ) => {
                let random = Math.floor( Math.random() * delays.length );
                let randomDelay = delays[random];

                delays.splice( random, 1 );

                item.style.transitionDelay = randomDelay + 'ms';
            } );
        } );
    }
}